import { Map, APIProvider } from "@vis.gl/react-google-maps";

export function GoogleMapsApiProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <APIProvider
      apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
      // Pin to 3.64: DrawingManager removed in Maps JS API 3.65 (the floating
      // "weekly" default). Temporary — task/service-area selection depends on
      // google.maps.drawing. Migrate to custom drawing, then drop this pin.
      version="3.64"
      libraries={["drawing", "geometry"]}
    >
      <Map
        zoom={13}
        center={{ lat: 43.6532, lng: -79.3832 }}
        mapId={"3667d2e0a1e93d2b"}
      >
        {children}
      </Map>
    </APIProvider>
  );
}
